import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Constant } from '../../../domain/constants';
import IconAirportBlack from '../../assets/iconAirportBlack';
import IconLocationBlack from '../../assets/iconLocationBlack';
import IconPort from '../../assets/iconPort';
import '../../assets/saas/atoms/_tags.scss';
const Tag = ({ cssClass, title, icon, cssstyles, location_type }) => {
    const parseStyleString = (styleStr) => {
        // Remove the curly braces and split into key-value pairs
        const styleObj = {};
        styleStr
            .replace(/^{|}$/g, "") // Remove the surrounding braces
            .split(";") // Split by semicolon to get individual declarations
            .filter(Boolean) // Remove empty entries
            .forEach((declaration) => {
            const [key, value] = declaration.split(":").map((item) => item.trim());
            if (key && value) {
                // Convert CSS properties to camelCase for React
                const camelCaseKey = key.replace(/-([a-z])/g, (match, char) => char.toUpperCase());
                styleObj[camelCaseKey] = value;
            }
        });
        return styleObj;
    };
    return (_jsxs("div", { className: `tag ${cssClass ? `tag--${cssClass}` : ""}`, style: parseStyleString(cssstyles ? cssstyles : ""), children: [location_type === Constant.DEFAULT ? (_jsx(IconLocationBlack, {})) : null, location_type == Constant.AIRPORT ? (_jsx(IconAirportBlack, {})) : null, location_type == Constant.PORT ? (_jsx(IconPort, {})) : null, !location_type &&
                icon && _jsx(IconAirportBlack, {}), _jsx("span", { className: 'tag__text-inner', children: title })] }));
};
export default Tag;
